import type { FC, ReactNode } from 'react'

import { Check, X } from 'lucide-react'
import { Logo } from '@/components/generals/logo'
import { Scallop } from '@/components/generals/scallop'
import { SectionHeading } from '@/components/generals/section-heading'
import { Sticker } from '@/components/generals/sticker'
import { COMPARISON } from '@/constants/home'

export const Comparison: FC = (): ReactNode => {
    return (
        <section id='compare' aria-labelledby='compare-title' className='relative bg-cream py-24 sm:py-32'>
            <Scallop className='text-cream' />

            <div className='mx-auto max-w-6xl px-5 sm:px-8'>
                <SectionHeading
                    id='compare-title'
                    lines={['An agency, minus', 'the headaches']}
                    sticker='Us vs. them'
                    stickerShape='burst'
                    stickerColor='text-mint'
                />

                <div className='relative mt-16 grid gap-6 md:grid-cols-2 md:gap-10'>
                    <div className='reveal-left rounded-[2.5rem] border-2 border-dashed border-plum/25 bg-cream-deep p-7 sm:p-10'>
                        <h3 className='font-heading text-[2rem] leading-none text-plum/70'>
                            The usual agency
                        </h3>

                        <ul className='mt-8 space-y-4'>
                            {COMPARISON.them.map((item) => (
                                <li key={item} className='flex items-start gap-3 text-plum/70 transition-all duration-300 hover:translate-x-1 hover:text-plum hover:line-through hover:decoration-coral hover:decoration-2'>
                                    <span className='mt-0.5 grid size-6 shrink-0 place-items-center rounded-full bg-plum/10 text-plum/60'>
                                        <X className='size-3.5' strokeWidth={3} aria-hidden='true' />
                                    </span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className='reveal-right rounded-[2.5rem] border-2 border-plum bg-mint p-7 shadow-[0_6px_0_0_var(--color-plum)] sm:p-10'>
                        <h3 className='font-heading text-[2rem] leading-none text-plum'>
                            <Logo className='text-[2rem]' />
                            <span className='sr-only'> Studio</span>
                        </h3>

                        <ul className='mt-8 space-y-4'>
                            {COMPARISON.us.map((item) => (
                                <li key={item} className='group/item flex items-start gap-3 font-medium text-plum transition-transform duration-300 hover:translate-x-1'>
                                    <span className='mt-0.5 grid size-6 shrink-0 place-items-center rounded-full bg-plum text-cream transition-transform duration-300 group-hover/item:scale-125 group-hover/item:rotate-12'>
                                        <Check className='size-3.5' strokeWidth={3} aria-hidden='true' />
                                    </span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <Sticker
                        label='VS'
                        shape='burst'
                        colorClassName='text-butter'
                        className='absolute top-1/2 left-1/2 hidden size-24 -translate-x-1/2 -translate-y-1/2 rotate-12 text-3xl [--reveal-delay:450ms] reveal-pop motion-safe:animate-wiggle md:inline-grid'
                    />
                </div>
            </div>
        </section>
    )
}
